(function () {
  var STORAGE_KEY = 'georgia:favorites';

  function readAll() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeAll(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* storage unavailable, ignore */
    }
    document.dispatchEvent(new CustomEvent('georgia:favorites-changed', { detail: { items: items } }));
  }

  function has(id) {
    return readAll().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function toggle(data) {
    var items = readAll();
    var index = items.findIndex(function (item) {
      return String(item.id) === String(data.id);
    });
    var active;
    if (index > -1) {
      items.splice(index, 1);
      active = false;
    } else {
      items.push(data);
      active = true;
    }
    writeAll(items);
    return active;
  }

  function remove(id) {
    var items = readAll().filter(function (item) {
      return String(item.id) !== String(id);
    });
    writeAll(items);
  }

  window.GeorgiaFavorites = {
    getAll: readAll,
    has: has,
    toggle: toggle,
    remove: remove,
  };

  class GeorgiaFavoriteToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.productId = this.dataset.productId;
      this.sync();
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        window.GeorgiaFavorites.toggle({
          id: this.productId,
          variantId: this.dataset.variantId,
          title: this.dataset.title,
          image: this.dataset.image,
          price: this.dataset.price,
          url: this.dataset.url,
        });
        this.sync();
      });
      this._onChange = () => this.sync();
      document.addEventListener('georgia:favorites-changed', this._onChange);
    }

    disconnectedCallback() {
      if (this._onChange) {
        document.removeEventListener('georgia:favorites-changed', this._onChange);
      }
    }

    sync() {
      var active = window.GeorgiaFavorites.has(this.productId);
      this.classList.toggle('is-active', active);
      if (this.button) {
        this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
      var activeLabel = this.dataset.activeLabel;
      var label = this.dataset.label;
      var textEl = this.querySelector('[data-favorite-label]');
      if (textEl && (activeLabel || label)) {
        textEl.textContent = active ? activeLabel || label : label || activeLabel;
      }
    }
  }

  if (!customElements.get('georgia-favorite-toggle')) {
    customElements.define('georgia-favorite-toggle', GeorgiaFavoriteToggle);
  }

  class GeorgiaFavoritesPanel extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-georgia-favorites-list]');
      this.render();
      this._onChange = () => this.render();
      document.addEventListener('georgia:favorites-changed', this._onChange);
    }

    disconnectedCallback() {
      if (this._onChange) {
        document.removeEventListener('georgia:favorites-changed', this._onChange);
      }
    }

    render() {
      var items = window.GeorgiaFavorites.getAll();
      document.querySelectorAll('[data-georgia-favorites-count]').forEach(function (el) {
        el.textContent = items.length;
      });
      if (!this.list) return;
      this.list.innerHTML = '';
      if (items.length === 0) {
        var empty = document.createElement('p');
        empty.className = 'georgia-favorites-panel__empty';
        empty.textContent = 'Aún no tenés favoritos. Tocá el corazón en un producto para guardarlo aquí.';
        this.list.appendChild(empty);
        return;
      }
      items.forEach((item) => {
        var row = document.createElement('div');
        row.className = 'georgia-favorite-row';
        row.innerHTML =
          '<a href="' + item.url + '"><img class="georgia-favorite-row__image" src="' + item.image + '" alt="" loading="lazy"></a>' +
          '<div class="georgia-favorite-row__info">' +
          '<a class="georgia-favorite-row__title" href="' + item.url + '">' + item.title + '</a>' +
          '<span class="georgia-favorite-row__price">' + item.price + '</span>' +
          '</div>' +
          '<div class="georgia-favorite-row__actions">' +
          '<button type="button" class="georgia-favorite-row__add">Añadir</button>' +
          '<button type="button" class="georgia-favorite-row__remove" aria-label="Quitar de favoritos">' +
          '<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '</button>' +
          '</div>';
        row.querySelector('.georgia-favorite-row__add').addEventListener('click', () => this.addToCart(item));
        row.querySelector('.georgia-favorite-row__remove').addEventListener('click', () => {
          window.GeorgiaFavorites.remove(item.id);
        });
        this.list.appendChild(row);
      });
    }

    addToCart(item) {
      var variantId = item.variantId || item.id;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then((res) => {
          if (res.ok) {
            window.location.reload();
          }
        })
        .catch(function () {});
    }
  }

  if (!customElements.get('georgia-favorites-panel')) {
    customElements.define('georgia-favorites-panel', GeorgiaFavoritesPanel);
  }

  class GeorgiaCartTabs extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-georgia-cart-tabs-root]') || this.parentElement;
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-georgia-tab]'));
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.activate(btn.dataset.georgiaTab));
      });
    }

    activate(tab) {
      if (!this.root) return;
      this.buttons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.georgiaTab === tab);
      });
      this.root.querySelectorAll('[data-georgia-tab-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.georgiaTabPanel !== tab;
      });
    }
  }

  if (!customElements.get('georgia-cart-tabs')) {
    customElements.define('georgia-cart-tabs', GeorgiaCartTabs);
  }
})();
